import en from 'i18n/english';
import React from 'react';

import Container from 'components/Container/Container';
import Hero from 'components/Hero/Hero';
import Layout from 'components/Layout';
import Seo from 'components/Seo';
import TextLayoutContainer from 'components/TextLayoutContainer/TextLayoutContainer';

import { banner } from 'styles/pages/common.module.scss';

const PostalPage = () => (
  <Layout fullWidth>
    <Seo title="Shipping" />
    <Hero title="SHIPPING" containerClass={banner} />
    <Container withPadding>
      <TextLayoutContainer>
        <h2>{en.A}</h2>
        <p>
          {en._246}

          <br />
          {en._247}
        </p>
        <h2>{en._248}</h2>
        <p>{en._249}</p>
        <p>
          {en._250}
          <br /> {en._251}
        </p>
        <p>{en._252}</p>
        <p>
          <em>{en._253}</em>
        </p>
        <h2>{en._254}</h2>
        <p>
          {en._255}
          <br /> {en._256}
          <a href="http://www.taxydromiki.com/track">
            <strong>
              <span>{en._257}</span>
            </strong>
          </a>
        </p>
      </TextLayoutContainer>
    </Container>
  </Layout>
);

export default PostalPage;
